var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: {
        type: "border-card",
        "tab-position": "top",
        id: "tabs-reurb",
        value: _vm.selectedTab
      },
      on: { "tab-click": _vm.tabClick }
    },
    [
      _c("el-tab-pane", {
        attrs: { label: _vm.LABELS.DIARIO, name: "DIARIO" }
      }),
      _c("el-tab-pane", {
        attrs: { label: _vm.LABELS.MENSAL, name: "MENSAL" }
      }),
      _c("el-tab-pane", { attrs: { label: _vm.LABELS.ANUAL, name: "ANUAL" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52137ac4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52137ac4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_reurb/components/TabsPeriodo.vue
// module id = null
// module chunks = 